import React from 'react';

export default function AnalysisButtons({ selectedAnalysisType, setSelectedAnalysisType, handleDirectAnalysis, PROMPTS, selectedLanguage }) {
  const labels = PROMPTS.buttonLabels[selectedLanguage] || PROMPTS.buttonLabels.HINGLISH;

  if (selectedAnalysisType) {
    const label = selectedAnalysisType === PROMPTS.messageTypes.FLUP ? labels.FOLLOWUP
      : selectedAnalysisType === PROMPTS.messageTypes.RM ? labels.REMEDIES
      : selectedAnalysisType === PROMPTS.messageTypes.TL ? labels.TECHNICAL
      : labels.NEW;
    return (
      <div className="selected-button-wrapper">
        <button className={`analysis-btn selected`} onClick={() => setSelectedAnalysisType(null)} title="Click to unselect">
          <span className="button-label">{label}</span>
          <span className="unselect-icon">✕</span>
        </button>
      </div>
    );
  }

  return (
    <div className="analysis-buttons-grid">
      <button className="analysis-btn followup-btn" onClick={() => setSelectedAnalysisType(PROMPTS.messageTypes.FLUP)}>{labels.FOLLOWUP}</button>
      <button className="analysis-btn remedy-btn" onClick={() => handleDirectAnalysis(PROMPTS.messageTypes.RM)}>{labels.REMEDIES}</button>
      <button className="analysis-btn technical-btn" onClick={() => handleDirectAnalysis(PROMPTS.messageTypes.TL)}>{labels.TECHNICAL}</button>
      <button className="analysis-btn new-btn" onClick={() => setSelectedAnalysisType(PROMPTS.messageTypes.NQ)}>{labels.NEW}</button>
    </div>
  );
}